import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type ResultsState = {
  currentTab:
    | 'interview'
    | 'written'
    | 'HR'
    | 'programming'
    | 'Drive'
    | 'cloudPrep'; // ✅ added

  selectedStudent: {
    name: string;
    id: string;
  };
};

const initialState: ResultsState = {
  currentTab: 'written',
  selectedStudent: {
    name: '',
    id: ''
  }
};

const ResultsSlice = createSlice({
  name: 'results',
  initialState,
  reducers: {
    setCurrentTab: (
      state,
      action: PayloadAction<
        'interview' | 'written' | 'HR' | 'programming' | 'Drive' | 'cloudPrep'
      >
    ) => {
      state.currentTab = action.payload;
    },

    setSelectedStudent: (state, action) => {
      state.selectedStudent = action.payload;
    }
  }
});

export const { setCurrentTab, setSelectedStudent } = ResultsSlice.actions;
export default ResultsSlice.reducer;
